import CircularProgress from "@material-ui/core/CircularProgress";
import { Theme } from "@material-ui/core/styles";
import { BaseCSSProperties, makeStyles } from "@material-ui/styles";
import { spaceBetween } from "../../../../common/util/Array/spaceBetween";
import "./animation.css";

interface Props {
    size?: string | number;
    style?: BaseCSSProperties;
    className?: string;
}
export default function ShurikenProgress({ size, style, className }: Props) {
    const c = useShurikenProgressStyles({ size, style });
    return (
        <div className={spaceBetween("center", c.container, className)}>
            <CircularProgress
                className={spaceBetween("ShurikenProgress", c.img)}
            />
        </div>
    );
}
const useShurikenProgressStyles = makeStyles<
    Theme,
    {
        size?: string | number;
        style?: BaseCSSProperties;
    }
>({
    container: ({ style }) => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...style,
    }),
    img: ({ size }) => ({
        width: size,
        height: size,
        maxWidth: size,
        maxHeight: size,
        minWidth: size,
        minHeight: size,
    }),
});

export function FullScreenShurikenProgress({ style, size }: Props) {
    const c = useFullScreenShurikenProgressStyles({ style });
    return (
        <div className={c.container}>
            <ShurikenProgress size={size || "20%"} />
        </div>
    );
}
const useFullScreenShurikenProgressStyles = makeStyles<
    Theme,
    { style?: BaseCSSProperties }
>({
    container: ({ style }) => ({
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...style,
    }),
});
